export default __webpack_public_path__ + "static/media/belaz-icon.68820e91.svg";